import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";
import { API, FARO_LOGO } from "@/lib/faro";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Si el email existe, recibirás un enlace en unos minutos");
    } catch (err) {
      toast.error("No se pudo procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--faro-blue-deep)] faro-noise px-5" data-testid="admin-forgot-page">
      <div className="relative w-full max-w-md">
        <Link to="/admin/login" className="inline-flex items-center gap-1 text-sm font-semibold text-white/70 hover:text-white mb-6">
          <ArrowLeft size={14} /> Volver al login
        </Link>
        <div className="rounded-3xl bg-white p-8 shadow-2xl">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl overflow-hidden border border-[rgba(30,42,143,0.15)]">
              <img src={FARO_LOGO} alt="Faro" className="w-full h-full object-cover" />
            </div>
            <div>
              <div className="font-display font-black text-lg text-[var(--faro-blue)]">Panel Faro</div>
              <div className="text-xs uppercase tracking-[0.18em] font-bold text-[var(--faro-red)]">Recuperar acceso</div>
            </div>
          </div>

          <h1 className="font-display font-black text-2xl mt-6 flex items-center gap-2">
            <Mail size={20} className="text-[var(--faro-blue)]" /> Restablecer contraseña
          </h1>

          {sent ? (
            <div className="mt-6 p-5 rounded-2xl bg-[var(--faro-bg)]" data-testid="forgot-sent">
              <p className="text-sm text-[var(--faro-text)]">
                Si el email <b>{email}</b> corresponde a una cuenta administrador, recibirás un enlace para restablecer tu contraseña en los próximos minutos. Revisa también la carpeta de spam.
              </p>
              <p className="text-xs text-[var(--faro-text-soft)] mt-3">
                El enlace es válido durante 1 hora.
              </p>
              <Link to="/admin/login" className="btn-pill btn-secondary mt-4 inline-flex text-sm">
                Volver al login
              </Link>
            </div>
          ) : (
            <>
              <p className="mt-3 text-sm text-[var(--faro-text-soft)]">
                Introduce el email con el que accedes al panel y te enviaremos un enlace para crear una nueva contraseña.
              </p>
              <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
                <label className="block">
                  <span className="text-xs uppercase tracking-[0.15em] font-bold text-[var(--faro-blue)]">Email</span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email"
                    className="mt-1 w-full rounded-xl border border-[rgba(30,42,143,0.15)] px-4 py-3 outline-none focus:border-[var(--faro-blue)] focus:ring-2 focus:ring-[rgba(30,42,143,0.1)]"
                    placeholder="info@autoescuelasfaro.com"
                    required
                  />
                </label>
                <button type="submit" disabled={loading} data-testid="forgot-submit" className="btn-pill btn-primary w-full justify-center disabled:opacity-60">
                  {loading ? "Enviando..." : "Enviarme el enlace"} <ArrowRight size={16} />
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
